import type { SVGProps } from "react";

/** The rail glyph for คลัง: three books on a shelf, drawn like the other 20×20 navigation strokes. */
export function LibraryIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="size-[18px] shrink-0"
      {...props}
    >
      <rect x="3" y="3.5" width="3.5" height="13" rx="0.8" />
      <rect x="8" y="5.5" width="3.5" height="11" rx="0.8" />
      <path d="M13.2 6.2l3.2-.9 2.6 10.4-3.2.9z" />
    </svg>
  );
}
